import React, { useState } from "react";
import { View, StyleSheet } from "react-native";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import { useCreateTenantMutation } from "../graphql/generated/graphql";
import { RootStackParamList } from "../navigation/AppNavigator.web";
import CustomText from "../components/common/general/CustomText/CustomText";
import CustomSpacing from "../components/common/layout/CustomSpacing/CustomSpacing";
import CustomButton from "../components/common/general/CustomButton/CustomButton";
import CreateTenantForm from "../containers/tenantDashboard/createTenantForm";
import DefaultLayout from "../layouts/DefaultLayout.web";

function CreateTenantView() {
  const navigation = useNavigation<NavigationProp<RootStackParamList>>();
  const [createTenant, { loading, error }] = useCreateTenantMutation();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleGoBack = () => {
    navigation.navigate("Admin");
  };

  const handleSubmit = async (data) => {
    try {
      setErrorMessage(null);

      const result = await createTenant({
        variables: {
          tenant: data,
        },
      });

      if (result.data?.createTenant?.success) {
        navigation.navigate("Admin");
      } else {
        const errorMsg = result.data?.createTenant?.message || "Failed to create tenant";
        setErrorMessage(errorMsg);
        console.error("Failed to create tenant:", errorMsg);
      }
    } catch (err) {
      const errorMsg = "An unexpected error occurred while creating the tenant";
      setErrorMessage(errorMsg);
      console.error("Error creating tenant:", err);
    }
  };

  return (
    <DefaultLayout pageHasChat={false}>
      <View style={styles.container}>
        <CustomButton
          text="← Back to Dashboard"
          onPress={handleGoBack}
          useTranslationText={false}
          styleType="transparent"
          size="s"
          style={styles.backButton}
        />
        <CustomSpacing size="m" />

        <CustomText
          role="header"
          text="Create New Tenant"
          size="l"
          textType="display"
          weight="ultraBold"
          useTranslationText={false}
        />
        <CustomSpacing size="xl" />

        {errorMessage && (
          <>
            <View style={styles.errorContainer}>
              <CustomText text={errorMessage} style={styles.errorText} useTranslationText={false} />
            </View>
            <CustomSpacing size="l" />
          </>
        )}

        <CreateTenantForm onSubmit={handleSubmit} loading={loading} />
      </View>
    </DefaultLayout>
  );
}

const styles = StyleSheet.create({
  container: {
    marginVertical: "auto",
    width: "100%",
    maxWidth: 800,
    paddingHorizontal: 20,
  },
  backButton: {
    alignSelf: "flex-start",
  },
  errorContainer: {
    backgroundColor: "#f8d7da",
    borderColor: "#f5c6cb",
    borderWidth: 1,
    borderRadius: 4,
    padding: 12,
  },
  errorText: {
    color: "#721c24",
    fontSize: 14,
  },
});

export default CreateTenantView;
